import { Component, OnInit, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';

import { BaseComponent } from '../base/base.component';
import { AttachedDocuments, DragAndDropDocument, FileData, ReportTemplate } from '../../models';
import {
  DragAndDropService,
  FileService,
  FormlyService,
  GridService,
  ModalService,
  NotificationService,
} from '../../services';
import { FileTypes } from '../../constants';
import { GridComponent } from '../grids';

@Component({
  selector: 'app-email-modal',
  templateUrl: './email-modal.component.html',
  styleUrl: './email-modal.component.scss',
})
export class EmailModalComponent extends BaseComponent implements OnInit {
  @ViewChild('contactsGrid', { static: true }) grid: GridComponent;

  fields: FormlyFieldConfig[];
  header = $localize`Email`;
  gridHeader = $localize`Email Contacts`;
  submitText = $localize`Send Email`;
  submitIcon = 'envelope';
  gridCssClass = 'email-modal-grid';

  additionalHeader = $localize`Additional Attachments`;
  dragAndDropClass = 'dropdiv-small';
  dragAndDropProgressClass = 'progress-small';
  dragAndDropHeader = $localize`Add`;
  dragAndDropText = $localize`Click HERE or drag file to attach to email`;
  processingText = $localize`Attaching files`;

  attachedDocuments: AttachedDocuments[];

  reportTemplate: ReportTemplate = {
    ccEmail: '',
    email: '',
    emailBody: '',
    emailContacts: [],
    emailSubject: '',
    report: '',
    sellingCompany: '',
    suffix: '',
    template: undefined,
  };

  private dragAndDropDocument: DragAndDropDocument = { folderName: '', subFolderName: '', fileName: '', container: '' };
  private fileFormData: FormData;

  attachedColumnDefs: ColDef[] = [this.gridService.text('documentName', $localize`Document Name`)];

  columnDefs: ColDef[] = [
    ...this.gridService.checkboxRowSelect('forename', $localize`Forename`, true),
    this.gridService.text('surname', $localize`Surname`),
    this.gridService.text('email', $localize`Email`),
  ];

  constructor(
    private dragAndDropService: DragAndDropService,
    private fileService: FileService,
    private formlyService: FormlyService,
    private gridService: GridService,
    private modalService: ModalService,
    private notificationService: NotificationService,
  ) {
    super();
  }

  ngOnInit() {
    this.dragAndDropDocument.folderName = this.reportTemplate.emailSubject;
    this.dragAndDropDocument.subFolderName = $localize`Attachments`;
    this.getFields();
    this.listFiles();
  }

  private getFields() {
    this.fields = [
      this.formlyService.text('email', $localize`To Email`),
      this.formlyService.text('ccEmail', $localize`CC Email`),
      this.formlyService.text('emailSubject', $localize`Subject`),
      this.formlyService.textarea('emailBody', $localize`Body`),
    ];
  }

  email() {
    this.reportTemplate.emailContacts = this.grid?.selectedRows;
    this.modalService.close(this.reportTemplate);
  }

  attachFiles(file: FileData) {
    this.dragAndDropDocument.fileName = file.name;

    const fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
    if (
      fileType == FileTypes.jpeg ||
      fileType == FileTypes.jpg ||
      fileType == FileTypes.png ||
      fileType == FileTypes.bmp
    ) {
      this.fileFormData = this.fileService.imageToFormData(file.src);
      this.dragAndDropService.uploadImage(this.dragAndDropDocument, this.fileFormData).subscribe(() => {});
    } else {
      this.fileFormData = this.fileService.fileToFormData(file.src);
      this.dragAndDropService.uploadFile(this.dragAndDropDocument, this.fileFormData).subscribe(() => {});
    }
    this.listFiles();
    this.notificationService.success($localize`File attached successfully`);
  }

  openDocument(row: any) {
    this.dragAndDropService.openPreview(row.fullPath);
  }

  removeDocument(model: any) {
    this.dragAndDropService.removeFile(model.fullPath).subscribe(() => {
      this.listFiles();
      this.notificationService.success($localize`File removed successfully`);
    });
  }

  private listFiles() {
    setTimeout(() => {
      this.dragAndDropService
        .listFiles(this.dragAndDropDocument)
        .subscribe((model: AttachedDocuments[]) => (this.attachedDocuments = model));
    }, 0);
  }
}
